/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminBusinessDto, AdminBusinessRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminBusinessService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name GetBusiness
   * @summary Get Business by ID
   * @request GET:/v1/admin/businesses/{businessId}
   * @secure
   */
  getBusiness = (businessId: number, params: RequestParams = {}) =>
    this.http.request<AdminBusinessDto, any>({
      path: `/v1/admin/businesses/${businessId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name UpdateBusiness
   * @summary Update Business
   * @request PUT:/v1/admin/businesses/{businessId}
   * @secure
   */
  updateBusiness = (
    businessId: number,
    data: AdminBusinessRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminBusinessDto, any>({
      path: `/v1/admin/businesses/${businessId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name DeleteBusiness
   * @summary Delete Business
   * @request DELETE:/v1/admin/businesses/{businessId}
   * @secure
   */
  deleteBusiness = (businessId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/businesses/${businessId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name SetPrimaryBusiness
   * @summary Set Primary Business
   * @request PUT:/v1/admin/businesses/{businessId}/set-primary
   * @secure
   */
  setPrimaryBusiness = (businessId: number, params: RequestParams = {}) =>
    this.http.request<AdminBusinessDto, any>({
      path: `/v1/admin/businesses/${businessId}/set-primary`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name GetBusinesses
   * @summary Get Businesses
   * @request GET:/v1/admin/businesses
   * @secure
   */
  getBusinesses = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminBusinessDto[], any>({
      path: `/v1/admin/businesses`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBusinessService
   * @name CreateBusiness
   * @summary Create Business
   * @request POST:/v1/admin/businesses
   * @secure
   */
  createBusiness = (data: AdminBusinessRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminBusinessDto, any>({
      path: `/v1/admin/businesses`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
